import { application } from '../application'

import MerchantMenuTabletCarouselController from './menu/tablet/carousel_controller.js'
import MerchantProductPageController from './product_page_controller'
import MerchantProductPageOptionController from './product_page/option_controller'
import MerchantProductPageModifierController from './product_page/modifier_controller'
import MerchantProductPageModifierRuleController from './product_page/modifier_rule_controller'
import MerchantProductPageNavigationController from './product_page/navigation_controller'
import MerchantProductPageNavigationItemController from './product_page/navigation_item_controller'
import MerchantProductPageNavigationPageController from './product_page/navigation_page_controller'
import MerchantProductPageScrollToController from './product_page/scroll_to_controller'
import MerchantProductPageScrollToItemController from './product_page/scroll_to_item_controller'
import MerchantMenuDeliveryTakeoutNavigation from './menu/delivery_takeout/navigation_controller'

import MerchantTabletAuthorizationVerify from './tablet/authorization/verify_controller.js'
import MerchantTabletAuthorizationRequest from './tablet/authorization/request_controller.js'
import MerchantTabletAuthorizationStatus from './tablet/authorization/status_controller.js'

import MerchantCheckoutShippingMapController from './checkout/shipping/map_controller.js'
import MerchantCheckoutShippingGeolocationController from './checkout/shipping/geolocation_controller.js'
import MerchantCheckoutTabScannerController from './checkout/tab_scanner_controller.js'
import MerchantCheckoutAwaitingPayment from './checkout/awaiting_payment_controller.js'
import MerchantCheckoutCreditCardController from './checkout/credit_card_controller.js'
import MerchantCheckoutCreditCardAuthController from './checkout/credit_card_auth_controller.js'
import MerchantCheckoutPaymentChangeController from './checkout/payment_change_controller.js'

application.register('merchant--tablet--authorization-verify', MerchantTabletAuthorizationVerify)
application.register('merchant--tablet--authorization-request', MerchantTabletAuthorizationRequest)
application.register('merchant--tablet--authorization-status', MerchantTabletAuthorizationStatus)

application.register('merchant--checkout--shipping--map', MerchantCheckoutShippingMapController)
application.register('merchant--checkout--shipping--geolocation', MerchantCheckoutShippingGeolocationController)
application.register('merchant--checkout--tab-scanner', MerchantCheckoutTabScannerController)
application.register('merchant--checkout--awaiting-payment', MerchantCheckoutAwaitingPayment)
application.register('merchant--checkout--credit-card', MerchantCheckoutCreditCardController)
application.register('merchant--checkout--credit-card-auth', MerchantCheckoutCreditCardAuthController)
application.register('merchant--checkout--payment-change', MerchantCheckoutPaymentChangeController)

application.register('merchant-menu-tablet--carousel', MerchantMenuTabletCarouselController)
application.register('merchant-product-page', MerchantProductPageController)
application.register('merchant-product-page--option', MerchantProductPageOptionController)
application.register('merchant-product-page--modifier', MerchantProductPageModifierController)
application.register('merchant-product-page--modifier-rule', MerchantProductPageModifierRuleController)
application.register('merchant-product-page--navigation', MerchantProductPageNavigationController)
application.register('merchant-product-page--navigation-item', MerchantProductPageNavigationItemController)
application.register('merchant-product-page--navigation-page', MerchantProductPageNavigationPageController)
application.register('merchant-product-page--scroll-to', MerchantProductPageScrollToController)
application.register('merchant-product-page--scroll-to-item', MerchantProductPageScrollToItemController)
application.register('merchant-menu-delivery-takeout--navigation', MerchantMenuDeliveryTakeoutNavigation)
